import React, { useEffect, useState } from 'react';
import api from '../../../api/axiosConfig';
// import '../../../styles/forms.css';
// import '../../../styles/dashboard.css';

interface DonorAnimal {
  _id: string;
  animalId: string;
  owner_phone?: string;
  matched_owner_phone?: string;
  species: string;
  breed: string;
  age: number;
  bloodGroup: string;
  location: string;
}

interface BloodRequest {
  _id: string;
  requestedAnimalId: string;
  owner_phone?: string;
  requested_owner_phone?: string;
  species: string;
  breed: string;
  age: number;
  bloodGroup: string;
  location: string;
  quantity: string;
  reason: string;
  status: string;
  matchedDonors: DonorAnimal[];
}

const MatchedBloodRequests: React.FC = () => {
  const [matchedRequests, setMatchedRequests] = useState<BloodRequest[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatchedRequests = async () => {
      try {
        const res = await api.admin_api.get<BloodRequest[]>('/donor/matched');
        setMatchedRequests(res.data);
      } catch (err) {
        console.error('Failed to fetch matched requests:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMatchedRequests();
  }, []);

  return (
    <div>
      <h2>Matched Blood Requests</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-container">
        <table className="data-table" style={{ width: '100%' }}>
          <thead>
            <tr>
              <th style={{color:'black'}} colSpan={7}>Requested Animal</th>
              <th style={{color:'black'}} colSpan={6}>Matched Donor Animal</th>
            </tr>
            <tr>
              {/* Requested Animal Headers */}
              {/* <th>Prani Aadhar</th> */}
              <th>Species</th>
              <th>Breed</th>
              <th>Age</th>
              <th>Blood Group</th>
              <th>Location</th>
              <th>Reason</th>
              <th>Contact</th>

              {/* Donor Headers */}
              {/* <th>Prani Aadhar</th> */}
              <th>Species</th>
              <th>Breed</th>
              <th>Age</th>
              <th>Blood Group</th>
              <th>Location</th>
              <th>Contact</th>
            </tr>
          </thead>
          <tbody>
            {matchedRequests.map((req) =>
              req.matchedDonors && req.matchedDonors.length > 0 ? (
                req.matchedDonors.map((donor, index) => (
                  <tr className="matched-row-group" key={`${req._id}-${donor._id}`}>
                    {index === 0 ? (
                      <>
                        {/* <td rowSpan={req.matchedDonors.length}>{req.praniAadharNumber}</td> */}
                        <td rowSpan={req.matchedDonors.length}>{req.species}</td>
                        <td rowSpan={req.matchedDonors.length}>{req.breed}</td>
                        <td rowSpan={req.matchedDonors.length}>{req.age}</td>
                        <td rowSpan={req.matchedDonors.length}>{req.bloodGroup}</td>
                        <td rowSpan={req.matchedDonors.length}>{req.location}</td>
                        <td rowSpan={req.matchedDonors.length}>{req.reason}</td>
                        <td rowSpan={req.matchedDonors.length}>{req.requested_owner_phone || req.owner_phone}</td>
                      </>
                    ) : null}

                    {/* Donor Data */}
                    {/* <td>{donor.praniAadharNumber}</td> */}
                    <td>{donor.species}</td>
                    <td>{donor.breed}</td>
                    <td>{donor.age}</td>
                    <td>{donor.bloodGroup}</td>
                    <td>{donor.location}</td>
                    <td>{donor.matched_owner_phone || donor.owner_phone}</td>
                  </tr>
                ))
              ) : (
                <tr key={req._id}>
                  {/* Requested Animal */}
                  {/* <td>{req.praniAadharNumber}</td> */}
                  <td>{req.species}</td>
                  <td>{req.breed}</td>
                  <td>{req.age}</td>
                  <td>{req.bloodGroup}</td>
                  <td>{req.location}</td>
                  <td>{req.reason}</td>
                  <td>{req.requested_owner_phone || req.owner_phone}</td>

                  {/* No donors */}
                  <td colSpan={6} style={{ textAlign: 'center' }}>No matched donors</td>
                </tr>
              )
            )}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
};

export default MatchedBloodRequests;